import { createContext, useContext, useEffect, useState } from 'react';
import usePolledResource from '../util/usePolledResource';
import UWEEntityApi from '../api/UWEEntityApi';
import { AuthContext } from './AuthContext';

const OpenCasesContext = createContext();

export const OpenCasesProvider = ({ children }) => {
  const auth = useContext(AuthContext);
  const user = auth?.user?.user;
  const [data, setData] = useState([]);

  const [openCases] = usePolledResource({
    resourceFn: () => (auth?.user?.user && auth.user?.organizationalUnits?.length > 1 ? UWEEntityApi.getOpenCases() : Promise.resolve([])),
    dependencies: [user?.id],
    interval: 1000 * 60,
    initialValue: [],
  });

  useEffect(() => {
    if (!openCases) return;
    setData(openCases);
  }, [openCases]);

  return <OpenCasesContext.Provider value={data}>{children}</OpenCasesContext.Provider>;
};

export const useOpenCases = () => useContext(OpenCasesContext);
